"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var mobx_react_1 = require("mobx-react");
var react_i18next_1 = require("react-i18next");
var react_i18next_2 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var path_1 = require("../../definition/path");
var storeProvider_1 = require("../../storeProvider");
var ErrorDialog_1 = __importDefault(require("../../util/ErrorDialog"));
var components_1 = require("./components");
var Offer_module_scss_1 = __importDefault(require("./Offer.module.scss"));
var heroSlides = [
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_TRY_FREE"
    },
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_LEARN_MORE"
    },
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_TRY_FREE"
    },
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_LEARN_MORE"
    },
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_TRY_FREE"
    },
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_LEARN_MORE"
    },
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_TRY_FREE"
    },
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_LEARN_MORE"
    },
    {
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg/960px-A_public_high_school_teacher_in_a_classroom_in_the_United_States_08.jpg",
        clickUrl: "https://testkruthai.com",
        buttonKey: "OFFER_HERO_BUTTON_TRY_FREE"
    }
];
var Offer = function () {
    var t = (0, react_i18next_2.useTranslation)().t;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var offerStore = (0, storeProvider_1.useStore)().offerStore;
    var _a = (0, react_1.useState)(false), isCartDialogOpen = _a[0], setIsCartDialogOpen = _a[1];
    var _b = (0, react_1.useState)(""), toastMessage = _b[0], setToastMessage = _b[1];
    var toastTimeoutRef = (0, react_1.useRef)(null);
    var showToast = function (message) {
        setToastMessage(message);
        if (toastTimeoutRef.current) {
            window.clearTimeout(toastTimeoutRef.current);
        }
        toastTimeoutRef.current = window.setTimeout(function () {
            setToastMessage("");
            toastTimeoutRef.current = null;
        }, 2500);
    };
    (0, react_1.useEffect)(function () {
        offerStore.initializeSessionAndLoadOffers();
    }, [offerStore]);
    (0, react_1.useEffect)(function () {
        if (offerStore.selectedOffers.length === 0) {
            setIsCartDialogOpen(false);
        }
        else {
            setIsCartDialogOpen(true);
        }
    }, [offerStore.selectedOffers.length]);
    (0, react_1.useEffect)(function () {
        return function () {
            if (toastTimeoutRef.current) {
                window.clearTimeout(toastTimeoutRef.current);
            }
        };
    }, []);
    var products = offerStore.offers;
    var cartTotal = offerStore.selectedOffers.reduce(function (total, offer) { return total + offer.price; }, 0);
    var localizedSlides = heroSlides.map(function (slide) { return ({
        imageUrl: slide.imageUrl,
        clickUrl: slide.clickUrl,
        buttonText: t(slide.buttonKey)
    }); });
    var handleBuyNowClick = function (product) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (product.isDisabled ||
                        offerStore.isEnded(product) ||
                        ((_a = product.remainingSeats) !== null && _a !== void 0 ? _a : 0) <= 0) {
                        showToast(t("OFFER_TOAST_SOLD_OUT"));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, offerStore.purchaseSelectedOffers([product])];
                case 1:
                    response = _b.sent();
                    if (response.status === "success") {
                        navigate("".concat(path_1.Page.TicketPage, "?session-id=").concat(encodeURIComponent(offerStore.sessionId)), { replace: true });
                        return [2 /*return*/];
                    }
                    if (response.status === "pending") {
                        if (response.paymentUrl) {
                            window.open(response.paymentUrl, "_blank", "noopener,noreferrer");
                        }
                        navigate("".concat(path_1.Page.WaitingPurchasePage, "?order-id=").concat(encodeURIComponent(response.orderId || ""), "&session-id=").concat(encodeURIComponent(offerStore.sessionId)), { replace: true });
                        return [2 /*return*/];
                    }
                    showToast(t("OFFER_TOAST_PURCHASE_FAILED"));
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCartClick = function (product) {
        var _a;
        if (offerStore.isSelected(product.id)) {
            return;
        }
        if (product.isDisabled ||
            offerStore.isEnded(product) ||
            ((_a = product.remainingSeats) !== null && _a !== void 0 ? _a : 0) <= 0) {
            showToast(t("OFFER_TOAST_SOLD_OUT"));
            return;
        }
        offerStore.toggleCartSelection(product);
    };
    var handlePurchaseCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (offerStore.selectedOffers.length === 0) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, offerStore.purchaseSelectedOffers(offerStore.selectedOffers)];
                case 1:
                    response = _a.sent();
                    setIsCartDialogOpen(false);
                    if (response.status === "success") {
                        navigate("".concat(path_1.Page.TicketPage, "?session-id=").concat(encodeURIComponent(offerStore.sessionId)), { replace: true });
                        return [2 /*return*/];
                    }
                    if (response.status === "pending") {
                        if (response.paymentUrl) {
                            window.open(response.paymentUrl, "_blank", "noopener,noreferrer");
                        }
                        navigate("".concat(path_1.Page.WaitingPurchasePage, "?order-id=").concat(encodeURIComponent(response.orderId || ""), "&session-id=").concat(encodeURIComponent(offerStore.sessionId)), { replace: true });
                        return [2 /*return*/];
                    }
                    showToast(t("OFFER_TOAST_PURCHASE_FAILED"));
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOpenCartDialog = function () {
        setIsCartDialogOpen(true);
    };
    var handleCloseCartDialog = function () {
        setIsCartDialogOpen(false);
    };
    var handleRemoveFromCart = function (offer) {
        offerStore.toggleCartSelection(offer);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: Offer_module_scss_1.default.offerPageContainer, children: [toastMessage && ((0, jsx_runtime_1.jsx)("div", { className: Offer_module_scss_1.default.inlineToast, role: "status", "aria-live": "polite", children: toastMessage })), (0, jsx_runtime_1.jsx)(components_1.OfferUpperSection, { slides: localizedSlides }), (0, jsx_runtime_1.jsx)(components_1.OfferProductSection, { products: products, buyNowText: t("OFFER_BUY_NOW"), cartText: t("OFFER_CART"), onBuyNowClick: handleBuyNowClick, onCartClick: handleCartClick, isSelected: function (offerId) { return offerStore.isSelected(offerId); }, isLoading: offerStore.isLoadingOffers, onViewAll: function () { return navigate(path_1.Page.OffersPage); } }), (0, jsx_runtime_1.jsx)(components_1.OfferHighlightSection, {}), (0, jsx_runtime_1.jsx)(components_1.OfferLowerSection, {}), offerStore.selectedOffers.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: Offer_module_scss_1.default.collapsedCartBar, children: [(0, jsx_runtime_1.jsxs)("span", { className: Offer_module_scss_1.default.collapsedCartTotal, children: ["B", cartTotal.toLocaleString("th-TH")] }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: Offer_module_scss_1.default.collapsedCartPurchaseButton, onClick: handlePurchaseCart, disabled: offerStore.isPurchasing, "aria-label": t("OFFER_CART_COLLAPSED_PURCHASE", {
                            count: offerStore.selectedOffers.length
                        }), children: t("OFFER_CART_DIALOG_PURCHASE", {
                            count: offerStore.selectedOffers.length
                        }) }), (0, jsx_runtime_1.jsxs)("button", { type: "button", className: Offer_module_scss_1.default.floatingCartButton, onClick: handleOpenCartDialog, disabled: offerStore.isPurchasing, "aria-label": t("OFFER_CART_REVIEW_ARIA", {
                            count: offerStore.selectedOffers.length
                        }), children: [(0, jsx_runtime_1.jsx)("svg", { className: Offer_module_scss_1.default.floatingCartIcon, viewBox: "0 0 24 24", "aria-hidden": "true", children: (0, jsx_runtime_1.jsx)("path", { d: "M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 8.1 18ZM17 18C15.9 18 15.01 18 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 18.1 18ZM7.16 14.26L7.2 14H17C17.75 14 18.41 13.59 18.75 12.97L21.58 7.88C21.83 7.42 21.5 6.86 20.97 6.86H6.21L5.27 4.86H2V6.86H4L7.16 14.26Z" }) }), (0, jsx_runtime_1.jsx)("span", { className: Offer_module_scss_1.default.floatingCartCount, children: offerStore.selectedOffers.length })] })] })), isCartDialogOpen && ((0, jsx_runtime_1.jsx)("div", { className: Offer_module_scss_1.default.cartSheetLayer, children: (0, jsx_runtime_1.jsxs)("div", { className: Offer_module_scss_1.default.cartSheet, role: "dialog", "aria-modal": "true", "aria-label": t("OFFER_CART_DIALOG_ARIA_LABEL"), children: [(0, jsx_runtime_1.jsxs)("div", { className: Offer_module_scss_1.default.cartDialogHeader, children: [(0, jsx_runtime_1.jsx)("h3", { className: Offer_module_scss_1.default.cartDialogTitle, children: t("OFFER_CART_DIALOG_TITLE") }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: Offer_module_scss_1.default.cartDialogCloseButton, onClick: handleCloseCartDialog, children: t("OFFER_CART_DIALOG_COLLAPSE") })] }), (0, jsx_runtime_1.jsx)("div", { className: Offer_module_scss_1.default.cartDialogList, children: offerStore.selectedOffers.map(function (offer) { return ((0, jsx_runtime_1.jsxs)("div", { className: Offer_module_scss_1.default.cartDialogItem, children: [(0, jsx_runtime_1.jsx)("img", { className: Offer_module_scss_1.default.cartDialogItemImage, src: offer.imageUrl, alt: offer.title, loading: "lazy" }), (0, jsx_runtime_1.jsxs)("div", { className: Offer_module_scss_1.default.cartDialogItemMeta, children: [(0, jsx_runtime_1.jsx)("p", { className: Offer_module_scss_1.default.cartDialogItemTitle, children: offer.title }), (0, jsx_runtime_1.jsxs)("p", { className: Offer_module_scss_1.default.cartDialogItemPrice, children: ["B", offer.price] })] }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: Offer_module_scss_1.default.cartDialogRemoveButton, onClick: function () {
                                            return handleRemoveFromCart(offer);
                                        }, children: t("OFFER_CART_DIALOG_REMOVE") })] }, offer.id)); }) }), (0, jsx_runtime_1.jsxs)("div", { className: Offer_module_scss_1.default.cartSheetFooter, children: [(0, jsx_runtime_1.jsxs)("span", { className: Offer_module_scss_1.default.cartSheetTotal, children: [t("OFFER_CART_DIALOG_TOTAL"), ": B", cartTotal.toLocaleString("th-TH")] }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: Offer_module_scss_1.default.cartDialogPurchaseButton, onClick: handlePurchaseCart, disabled: offerStore.isPurchasing, children: t("OFFER_CART_DIALOG_PURCHASE", {
                                        count: offerStore.selectedOffers.length
                                    }) })] })] }) })), (0, jsx_runtime_1.jsx)(ErrorDialog_1.default, { open: Boolean(offerStore.errorMessage), title: t("OFFER_ERROR_TITLE"), message: offerStore.errorMessage || t("OFFER_ERROR_UNKNOWN"), onClose: offerStore.clearError })] }));
};
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(Offer));
